var _radialGradient, _path, _linearGradient, _path2, _linearGradient2, _polygon, _linearGradient3, _path3, _linearGradient4, _path4, _linearGradient5, _circle, _linearGradient6, _path5, _linearGradient7, _path6, _linearGradient8, _path7, _linearGradient9, _path8, _linearGradient10, _path9, _linearGradient11, _polygon2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDraftExpense(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "Rq6QyW_WEminwwpMnAwR7a",
    cx: 32,
    cy: 34,
    r: 32.002,
    gradientTransform: "matrix(1 0 0 -1 0 66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#afeeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.193,
    stopColor: "#bbf1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#d7f8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e1faff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Rq6QyW_WEminwwpMnAwR7a)",
    d: "M59.29,44H52V29h8c1.1,0,2.1-0.45,2.83-1.17C63.55,27.1,64,26.1,64,25c0-0.66-0.16-1.28-0.45-1.83C62.89,21.88,61.55,21,60,21h-9.5c-1.93,0-3.5-1.57-3.5-3.5c0-0.3,0.04-0.59,0.11-0.86c0.15-0.62,0.48-1.17,0.92-1.61C48.66,14.39,49.54,14,50.5,14H59c1.85,0,3.32-1.69,2.94-3.6C61.65,8.97,60.31,8,58.86,8H53.5C52.67,8,52,7.33,52,6.5S52.67,5,53.5,5h1.9c1.14,0,2.21-0.72,2.51-1.82C58.36,1.52,57.1,0,55.5,0H5.6C4.46,0,3.39,0.72,3.09,1.82C2.64,3.48,3.9,5,5.5,5h3c0.69,0,1.32,0.28,1.77,0.73c0.42,0.42,0.69,0.99,0.73,1.62C11.08,8.8,9.8,10,8.34,10H4.13c-1.45,0-2.79,0.97-3.07,2.4C0.68,14.31,2.15,16,4,16h14v5H5.17c-2.09,0-3.95,1.53-4.15,3.61C0.79,26.99,2.66,29,5,29h17.93c-3.01,5.95-7.13,14.27-6.98,15H4.71c-2.34,0-4.45,1.7-4.69,4.04C-0.25,50.72,1.87,53,4.5,53h8.86c1.3,0,2.5,0.94,2.63,2.24c0.15,1.5-1.02,2.76-2.49,2.76H7.16C5.54,58,4.09,59.22,4,60.84C3.92,62.58,5.29,64,7,64h49.84c1.62,0,3.07-1.22,3.16-2.84c0.08-1.74-1.29-3.16-3-3.16h-7.36c-1.3,0-2.5-0.94-2.63-2.24C46.86,54.26,48.03,53,49.5,53h10c2.63,0,4.75-2.28,4.48-4.96C63.74,45.7,61.63,44,59.29,44z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rq6QyW_WEminwwpMnAwR7b",
    x1: 27.942,
    x2: 27.942,
    y1: 21.489,
    y2: 37.772,
    gradientTransform: "matrix(1 0 0 -1 0 66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbaa5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffbb70"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Rq6QyW_WEminwwpMnAwR7b)",
    d: "M18.863,33.097c-2.62,2.607-3.966,6.207-3.672,9.769c0.166,1.942,2.51,2.707,3.933,1.284l21.609-21.662l-5.61-5.61L18.863,33.097z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rq6QyW_WEminwwpMnAwR7c",
    x1: -1074.23,
    x2: -1074.23,
    y1: 500.34,
    y2: 490.207,
    gradientTransform: "rotate(-134.999 -616.958 27.899)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3714d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#e4754e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e77b50"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#Rq6QyW_WEminwwpMnAwR7c)",
    points: "32.273,19.686 37.93,25.343 41.466,21.808 35.809,16.151"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rq6QyW_WEminwwpMnAwR7d",
    x1: 32,
    x2: 32,
    y1: 38.553,
    y2: 10.028,
    gradientTransform: "matrix(1 0 0 -1 0 66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#42d778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#34b171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34b171"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Rq6QyW_WEminwwpMnAwR7d)",
    d: "M58,32v21c0,1.66-1.34,3-3,3H9c-1.66,0-3-1.34-3-3V32c0-1.66,1.34-3,3-3h46C56.66,29,58,30.34,58,32z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rq6QyW_WEminwwpMnAwR7e",
    x1: 32,
    x2: 32,
    y1: 34.723,
    y2: 8.86,
    gradientTransform: "matrix(1 0 0 -1 0 66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#62de8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    stopColor: "#5dd18d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56be89"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Rq6QyW_WEminwwpMnAwR7e)",
    d: "M52,52H12c-1.105,0-2-0.895-2-2V35c0-1.105,0.895-2,2-2h40c1.105,0,2,0.895,2,2v15C54,51.105,53.105,52,52,52z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rq6QyW_WEminwwpMnAwR7f",
    x1: 32.5,
    x2: 32.5,
    y1: 48.186,
    y2: 19.542,
    gradientTransform: "matrix(1 0 0 -1 0 66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#42d778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#34b171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34b171"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 42.5,
    r: 6.5,
    fill: "url(#Rq6QyW_WEminwwpMnAwR7f)"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rq6QyW_WEminwwpMnAwR7g",
    x1: 13.999,
    x2: 13.999,
    y1: 42.638,
    y2: 2.285,
    gradientTransform: "matrix(1 0 0 -1 0 66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#62de8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    stopColor: "#5dd18d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56be89"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Rq6QyW_WEminwwpMnAwR7g)",
    d: "M21.98,53.31C21.83,54.87,20.41,56,18.85,56H9c-1.66,0-3-1.34-3-3V33h6c-1.1,0-2,0.9-2,2v15c0,1.1,0.9,2,2,2h9.82C21.97,52.4,22.03,52.85,21.98,53.31z"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rq6QyW_WEminwwpMnAwR7h",
    x1: 15.91,
    x2: 15.91,
    y1: 40.021,
    y2: -1.994,
    gradientTransform: "matrix(1 0 0 -1 0 66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#79e3a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    stopColor: "#75d89e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6fc89b"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Rq6QyW_WEminwwpMnAwR7h)",
    d: "M21.82,52H12c-1.1,0-2-0.9-2-2V35c0-1.1,0.9-2,2-2h1.36c1.3,0,2.5,0.94,2.63,2.24c0.15,1.5-1.02,2.76-2.49,2.76c-0.83,0-1.5,0.67-1.5,1.5s0.67,1.5,1.5,1.5h1.86c1.3,0,2.5,0.94,2.63,2.24c0.15,1.5-1.02,2.76-2.49,2.76H15c-1.1,0-2,0.9-2,2c0,0.55,0.22,1.05,0.59,1.41C13.95,49.78,14.45,50,15,50h4C20.31,50,21.42,50.83,21.82,52z"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rq6QyW_WEminwwpMnAwR7i",
    x1: 22.602,
    x2: 20.56,
    y1: 42.956,
    y2: 58.786,
    gradientTransform: "matrix(1 0 0 -1 0 66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3714d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#e4754e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e77b50"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Rq6QyW_WEminwwpMnAwR7i)",
    d: "M21.5,23c-4.687,0-8.5-3.813-8.5-8.5S16.813,6,21.5,6S30,9.813,30,14.5S26.187,23,21.5,23z M21.5,12c-1.379,0-2.5,1.121-2.5,2.5s1.121,2.5,2.5,2.5s2.5-1.121,2.5-2.5S22.879,12,21.5,12z"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rq6QyW_WEminwwpMnAwR7j",
    x1: 44.258,
    x2: 42.216,
    y1: 45.622,
    y2: 61.451,
    gradientTransform: "matrix(1 0 0 -1 0 66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3714d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#e4754e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e77b50"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Rq6QyW_WEminwwpMnAwR7j)",
    d: "M43.5,23c-4.687,0-8.5-3.813-8.5-8.5S38.813,6,43.5,6S52,9.813,52,14.5S48.187,23,43.5,23z M43.5,12c-1.379,0-2.5,1.121-2.5,2.5s1.121,2.5,2.5,2.5s2.5-1.121,2.5-2.5S44.879,12,43.5,12z"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rq6QyW_WEminwwpMnAwR7k",
    x1: 36.676,
    x2: 36.676,
    y1: 17.213,
    y2: 47.124,
    gradientTransform: "matrix(1 0 0 -1 0 66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5cb63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.076,
    stopColor: "#f6cc6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#fdd088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#ffd194"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd194"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Rq6QyW_WEminwwpMnAwR7k)",
    d: "M32.329,19.702l-2.836-2.821l-5.607,5.607l2.821,2.835l2.828,2.828l9.178,9.207l6.781,6.795c1.421,1.421,3.769,0.658,3.932-1.287c0.297-3.564-1.054-7.163-3.67-9.765L32.329,19.702z"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rq6QyW_WEminwwpMnAwR7l",
    x1: -448.837,
    x2: -448.837,
    y1: -189.748,
    y2: -199.881,
    gradientTransform: "scale(1 -1) rotate(45 -420.646 467.513)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3714d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#e4754e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e77b50"
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#Rq6QyW_WEminwwpMnAwR7l)",
    points: "32.343,19.688 26.686,25.344 23.15,21.809 28.807,16.152"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraftExpense);
export default __webpack_public_path__ + "static/media/Draft_Expense.19faac1de7a815864d938f2011d46a1b.svg";
export { ForwardRef as ReactComponent };